import { useMutation } from '@tanstack/react-query';
import { AttachmentDto, useApi } from '@issuemanager/api-client';
import { ExtendedAxiosError } from '@issuemanager/apps/client/hooks';
import {
  APP_ERROR_TYPE,
  useAppErrorHandler,
} from '@issuemanager/apps/client/contexts';

export function useGetAttachmentDownloadUrl() {
  const api = useApi();
  const appErrorHandler = useAppErrorHandler();

  return useMutation<
    AttachmentDto,
    ExtendedAxiosError,
    { hbDriveId: string; name: string }
  >({
    mutationKey: ['attachments-download-url'],
    // This is a GET request, but we are using a mutation
    // because we are getting the id when the button is clicked
    mutationFn: ({ hbDriveId, name }) =>
      api.attachmentsApi
        .downloadAttachment(hbDriveId, name)
        .then((r) => r.data),
    onError: (error) => {
      if (error.response?.status === 400) {
        appErrorHandler.setError({ type: APP_ERROR_TYPE.SCANNING_FILE });
      }
    },
  });
}
